
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
a {
      display:inline-flex;
      color:var(--neutral-white);
      text-decoration-line:none;
}

  a ghs-icon {
      margin-left:1rem;
}

  a ghs-icon {
      margin-top:-0.25rem;
}

  a ghs-icon {
      transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
      transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
      transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
      transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration:150ms;
}

  a ghs-icon {
      transition-duration:300ms;
}

  a:hover, a:focus {
      cursor:pointer;
}

  a:hover, a:focus {
      text-decoration-line:underline;
}

  a:hover ghs-icon, a:focus ghs-icon{
      transform:translateY(-40%);
    }
`;